import {useEffect, useState} from "react"
import Logo from "../assets/logo.png";
const readTheme = ()=>{
  const raw = localStorage.getItem("theme");
  if(!raw) return "light";
  try{ return JSON.parse(raw) }catch(e){ return raw }
}
export const Header = () => {
  const [theme,setTheme] = useState(readTheme);
  useEffect (() =>{
    try{ localStorage.setItem("theme",JSON.stringify(theme)) }catch(e){/* ignore */}
    // set theme class on root
    document.documentElement.className = '';
    if(theme) document.documentElement.classList.add(theme);
  },[theme])



  return (
    <header>
        <div className="logo">
            <img src={Logo} alt="ATask Logo" />
            <span>ATask</span>
        </div>
        <div className="themeSelector">
            <span onClick={()=> setTheme("light")} className={theme==="light" ? "light activeTheme":"light"}></span>
            <span onClick={()=> setTheme("medium")} className={theme==="medium" ? "medium activeTheme":"medium"}></span>
            <span onClick={()=> setTheme("dark")} className={theme==="dark" ? "dark activeTheme":"dark"}></span>
            <span onClick={()=> setTheme("gOne")} className={theme==="gOne" ? "gOne activeTheme":"gOne"}></span>
            <span onClick={()=> setTheme("gTwo")} className={theme==="gTwo" ? "gTwo activeTheme":"gTwo"}></span>
            <span onClick={()=> setTheme("gThree")} className={theme==="gThree" ? "gThree activeTheme":"gThree"}></span>
        </div>
    </header>
  )
}
